import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#030303]">
      {/* Header */}
      <div className="border-b border-[#1C1C1C]">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#71717A] hover:text-[#A1A1AA] transition-colors text-sm"
          >
            <ArrowLeft size={16} />
            Retour
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <header className="mb-16 text-center">
          <h1 
            className="text-3xl md:text-4xl text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Politique de Confidentialité
          </h1>
          <p className="text-[#D4AF37] text-sm tracking-[0.2em] uppercase">
            Clierxter Vision Lab
          </p>
        </header>

        <div className="space-y-12 text-[#A1A1AA] leading-relaxed">
          
          {/* Section 1 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              1. Introduction
            </h2>
            <p className="mb-4">
              Clierxter Vision Lab accorde une importance particulière à la protection des données personnelles de ses utilisatrices.
            </p>
            <p>
              Cette politique explique quelles données sont collectées, comment elles sont utilisées et quels sont vos droits.
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              2. Données collectées
            </h2>
            <p className="mb-4">
              Nous pouvons collecter les données suivantes :
            </p>
            <ul className="list-none space-y-2 ml-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>Informations d'identification (nom, email)</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>Informations de connexion</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>Données d'utilisation de la plateforme</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>Réponses aux outils et contenus générés</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>Informations de paiement (via Stripe uniquement)</span>
              </li>
            </ul>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              3. Utilisation des données
            </h2>
            <p className="mb-4">
              Les données sont utilisées pour :
            </p>
            <ul className="list-none space-y-2 ml-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>fournir et améliorer les services</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>personnaliser l'expérience utilisateur</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>gérer les abonnements</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>envoyer des communications (emails, notifications)</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>assurer la sécurité de la plateforme</span>
              </li>
            </ul>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              4. Partage des données
            </h2>
            <p className="mb-4">
              Les données ne sont jamais revendues.
            </p>
            <p className="mb-4">
              Elles peuvent être partagées uniquement avec des services nécessaires au fonctionnement :
            </p>
            <ul className="list-none space-y-2 ml-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>Stripe (paiements)</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>services d'emailing</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>hébergement sécurisé</span>
              </li>
            </ul>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              5. Sécurité
            </h2>
            <p>
              Nous mettons en place des mesures de sécurité pour protéger les données contre tout accès non autorisé.
            </p>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              6. Conservation
            </h2>
            <p>
              Les données sont conservées pendant la durée nécessaire à l'utilisation du service.
            </p>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              7. Vos droits
            </h2>
            <p className="mb-4">
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul className="list-none space-y-2 ml-4 mb-4">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>accès à vos données</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>rectification</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>suppression</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] mt-1.5">—</span>
                <span>limitation du traitement</span>
              </li>
            </ul>
            <p>
              Vous pouvez exercer vos droits en contactant : <a href="mailto:hello@clierxterapp.com" className="text-[#D4AF37] hover:underline">hello@clierxterapp.com</a>
            </p>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              8. Cookies
            </h2>
            <p>
              La plateforme peut utiliser des cookies pour améliorer l'expérience utilisateur.
            </p>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              9. Modification
            </h2>
            <p>
              Cette politique peut être modifiée à tout moment.
            </p>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="text-white text-xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              10. Droit applicable
            </h2>
            <p>
              Cette politique est régie par le droit suisse.
            </p>
          </section>

        </div>

        {/* Footer */}
        <footer className="mt-16 pt-8 border-t border-[#1C1C1C] text-center">
          <p className="text-[#52525B] text-sm">
            Clierxter Vision Lab
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
